import styled, { keyframes } from 'styled-components';
import { PulseAnimationI } from './interface';

const generateRandomAnimationDelayTime = (): string =>
  (Math.random() * (1.1 - 0.2) + 0.2).toFixed(1);

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  
  100% {
    transform: scale(1.4);
  }
`;

export const PulseAnimationContainer = styled.div<PulseAnimationI>`
  animation: ${pulseAnimation}
    ${({ durationInSeconds }): string => (durationInSeconds ? `${durationInSeconds}s` : '1.5s')}
    infinite alternate ease-in-out;
  animation-delay: ${(): string => `${generateRandomAnimationDelayTime()}s`};
`;
